import { defaultRouter } from 'app/common/router';

/**
 * Conditionally resolves a promise if route is unchanged
 * @param promise
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unlessRouteChanged = (promise: Promise<any>): Promise<any> => {
  let routeChanged = false;
  const unsubscribe = defaultRouter.subscribe(() => {
    routeChanged = true;
    unsubscribe();
  });
  return promise.then(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result: any) =>
      routeChanged
        ? Promise.reject(new Error('Route changed'))
        : Promise.resolve(result),
  );
};
